import { Loader } from "@caprikorn/dynamo-ui";
import type { FC } from "react";

import classes from "./PageLoader.module.css";

export const PageLoader: FC = () => (
  <div className={classes.container}>
    <Loader size="2xl" />
  </div>
);
